import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import(/* webpackChunkName: "root" */ "../views/Root.vue"),
    children: [
      {
        path: "/",
        redirect: "dashboard",
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: () =>
          import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
        meta: {
          requiresAuth: true,
          allowedRoles: [1, 3],
        },
      },
      {
        path: "accounts",
        component: () =>
          import(/* webpackChunkName: "accounts" */ "../views/Accounts/Accounts.vue"),
        children: [
          {
            path: "/",
            name: "Accounts",
            component: () =>
              import(
                  /* webpackChunkName: "accounts-index" */ "../views/Accounts/Index.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
          {
            path: "add",
            name: "Add Account",
            component: () =>
              import(
                  /* webpackChunkName: "account-add" */ "../views/Accounts/Add.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
          {
            path: ":id/edit",
            name: "Edit Account",
            component: () =>
              import(
                  /* webpackChunkName: "accounts-edit" */ "../views/Accounts/Edit.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
        ],
        meta: {
          requiresAuth: true,
          allowedRoles: [1],
        },
      },
      {
        path: "riders",
        component: () =>
          import(/* webpackChunkName: "riders" */ "../views/Riders/Riders.vue"),
        children: [
          {
            path: "/",
            name: "Riders",
            component: () =>
              import(
                /* webpackChunkName: "riders-index" */ "../views/Riders/Index.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1, 2],
            },
          },
          {
            path: "add",
            name: "Add Rider",
            component: () =>
              import(
                /* webpackChunkName: "riders-add" */ "../views/Riders/Add.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1, 2],
            },
          },
          {
            path: ":id/edit",
            name: "Edit Rider",
            component: () =>
              import(
                /* webpackChunkName: "riders-add" */ "../views/Riders/Edit.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1, 2],
            },
          },
        ],
      },
      {
        path: "finance",
        component: () =>
          import(/* webpackChunkName: "finance" */ "../views/Finance/Finance.vue"),
        children: [
          {
            path: "/",
            name: "Finance",
            component: () =>
              import(
                /* webpackChunkName: "finance-index" */ "../views/Finance/Index.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1, 3],
            },
          },
        ],
      },
      {
        path: "logs",
        component: () =>
          import(/* webpackChunkName: "logs" */ "../views/Logs/Logs.vue"),
        children: [
          {
            path: "/",
            name: "Logs",
            component: () =>
              import(
                /* webpackChunkName: "logs-index" */ "../views/Logs/Index.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
        ],
      },
      {
        path: "drivers",
        component: () =>
          import(
            /* webpackChunkName: "dirvers" */ "../views/Drivers/Drivers.vue"
          ),
        children: [
          {
            path: "/",
            name: "Drivers",
            component: () =>
              import(
                /* webpackChunkName: "drivers-index" */ "../views/Drivers/Index.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1, 2],
            },
          },
          {
            path: "add",
            name: "Add Driver",
            component: () =>
              import(
                /* webpackChunkName: "drivers-add" */ "../views/Drivers/Add.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
          {
            path: ":id/edit",
            name: "Edit Driver",
            component: () =>
              import(
                /* webpackChunkName: "drivers-edit" */ "../views/Drivers/Edit.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
        ],
      },
      {
        path: "rides",
        component: () =>
          import(/* webpackChunkName: "rides" */ "../views/Rides/Rides.vue"),
        children: [
          {
            path: "/",
            name: "Rides",
            component: () =>
              import(
                /* webpackChunkName: "rides-index" */ "../views/Rides/Index.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1, 2],
            },
          },
          {
            path: ":id/show",
            name: "show ride",
            component: () =>
              import(
                /* webpackChunkName: "ride-show" */ "../views/Rides/Show.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1, 2],
            },
          },
        ],
      },
      {
        path: "push-notification",
        name: "Push Notification",
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ "../views/PushNotification/PushNotification.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1],
        },
      },
      {
        path: "setting",
        name: "Site settings",
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ "../views/Setting/Setting.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1],
        },
      },
      {
        path: "manual-ride-booking",
        name: "Manual Ride Booking",
        component: () =>
          import(
            /* webpackChunkName: "manual-ride-booking" */ "../views/ManualRideBooking/Index.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1, 2],
        },
      },
      {
        path: "wallet-managment",
        name: "Wallet managment",
        component: () =>
          import(
            /* webpackChunkName: "wallet-managment" */ "../views/WalletManagment/Index.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1],
        },
      },
      {
        path: "loan-history",
        name: "loan history",
        component: () =>
          import(
            /* webpackChunkName: "loan-history" */ "../views/LoanHistory/Index.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1, 2],
        },
      },
      {
        path: "vehicle-types",
        component: () =>
          import(
            /* webpackChunkName: "vehicle-types" */ "../views/VehicleTypes/VehicleTypes.vue"
          ),
        children: [
          {
            path: "/",
            name: "Vehicle Type",
            component: () =>
              import(
                /* webpackChunkName: "vehicle-types-index" */ "../views/VehicleTypes/Index.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1, 2],
            },
          },
          {
            path: "add",
            name: "Add Vehicle Type",
            component: () =>
              import(
                /* webpackChunkName: "vehicle-types-add" */ "../views/VehicleTypes/Add.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
          {
            path: ":id/edit",
            name: "Edit Vehicle Type",
            component: () =>
              import(
                /* webpackChunkName: "vehicle-types-edit" */ "../views/VehicleTypes/Edit.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
        ],
      },
      {
        path: "vehicles",
        component: () =>
          import(
            /* webpackChunkName: "vehicles" */ "../views/Vehicles/Vehicles.vue"
          ),
        children: [
          {
            path: "/",
            name: "Vehicles",
            component: () =>
              import(
                /* webpackChunkName: "vehicles-index" */ "../views/Vehicles/Index.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1, 2],
            },
          },
          {
            path: "add",
            name: "Add Vehicle",
            component: () =>
              import(
                /* webpackChunkName: "vehicles-add" */ "../views/Vehicles/Add.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
          {
            path: ":id/edit",
            name: "Edit Vehicle",
            component: () =>
              import(
                /* webpackChunkName: "vehicles-edit" */ "../views/Vehicles/Edit.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
        ],
      },
      {
        path: "fqa",
        component: () =>
          import(
            /* webpackChunkName: "fqa" */ "../views/FQA/FQA.vue"
          ),
        children: [
          {
            path: "/",
            name: "FQA",
            component: () =>
              import(
                /* webpackChunkName: "FQA-index" */ "../views/FQA/Index.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1, 2, 3],
            },
          },
          {
            path: "add",
            name: "Add FQA",
            component: () =>
              import(
                /* webpackChunkName: "fqa-add" */ "../views/FQA/Add.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
          {
            path: ":id/edit",
            name: "Edit FQA",
            component: () =>
              import(
                /* webpackChunkName: "fqa-edit" */ "../views/FQA/Edit.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [1],
            },
          },
        ],
      },
      {
        path: "gods-view",
        name: "God's View",
        component: () =>
          import(
            /* webpackChunkName: "gods-view" */ "../views/GodsView/Index.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1, 2],
        },
      },
      {
        path: "sos",
        name: "SOS",
        component: () =>
          import(/* webpackChunkName: "gods-view" */ "../views/SOS/Index.vue"),
        meta: {
          requiresAuth: true,
          allowedRoles: [1, 2],
        },
      },
      {
        path: "sos-history",
        name: "SOS History",
        component: () =>
          import(
            /* webpackChunkName: "gods-view" */ "../views/SOSHistory/Index.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1, 2],
        },
      },
      {
        path: "payment-records",
        name: "Payment records",
        component: () =>
          import(
            /* webpackChunkName: "manual-ride-booking" */ "../views/PaymentRecords/PaymentRecords.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1, 3],
        },
      },
      {
        path: "reviews-and-ratings",
        name: "Review and rating",
        component: () =>
          import(
            /* webpackChunkName: "manual-ride-booking" */ "../views/ReviewsRating/Rating.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1],
        },
      },
      {
        path: "payment-records",
        name: "Payment records",
        component: () =>
          import(
            /* webpackChunkName: "manual-ride-booking" */ "../views/PaymentRecords/PaymentRecords.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1, 3],
        },
      },
      {
        path: "drivers/:id",
        name: "Driver Details",
        component: () =>
          import(
            /* webpackChunkName: "manual-ride-booking" */ "../views/Drivers/Show.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1, 2],
        },
      },
    ],
  },
  {
    path: "/corporate",
    component: () =>
      import(/* webpackChunkName: "corporate" */ "../views/Root.vue"),
    children: [
      {
        path: "/",
        name: "Corporate Index",
        component: () =>
          import(
            /* webpackChunkName: "corporate-index" */ "../views/Corporate/Index.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1, 3],
        },
      },
      {
        path: "dashboard",
        name: "Corporate Dashboard",
        component: () =>
          import(
            /* webpackChunkName: "corporate-dashboard" */ "../views/Corporate/Dashboard.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [4],
        },
      },
      {
        path: "tickets",
        name: "tickets",
        component: () =>
          import(
            /* webpackChunkName: "corporate-ticket" */ "../views/Tickets/Tickets.vue"
          ),
        children: [
          {
            path: "/",
            name: "Ticket Index",
            component: () =>
              import(
                /* webpackChunkName: "ticket-index" */ "../views/Tickets/Index.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [4],
            },
          },
        ],
      },
      {
        path: "employees",
        name: "employees",
        component: () =>
          import(
            /* webpackChunkName: "corporate-employees" */ "../views/Employees/Employees.vue"
          ),
        children: [
          {
            path: "/",
            name: "Employees Index",
            component: () =>
              import(
                /* webpackChunkName: "employees-index" */ "../views/Employees/Index.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [4],
            },
          },
          {
            path: "add",
            name: "Add Employee",
            component: () =>
              import(
                /* webpackChunkName: "add-employee" */ "../views/Employees/AddEmployee.vue"
              ),
            meta: {
              requiresAuth: true,
              allowedRoles: [4],
            },
          },
        ],
      },
      {
        path: "add",
        name: "Add Corporate",
        component: () =>
          import(
            /* webpackChunkName: "add-corporate" */ "../views/Corporate/Add.vue"
          ),
        meta: {
          requiresAuth: true,
          allowedRoles: [1],
        },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: "/role",
    name: "Role",
    component: () =>
      import(/* webpackChunkName: "role" */ "../views/Role.vue"),
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: "*",
    name: "404",
    component: () => import(/* webpackChunkName: "login" */ "../views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
